import { Middleware } from 'redux';

import { Logger } from '@futrli/shared-services';
import { queryClient } from '@futrli/views/core/queryClient';
import { SIGN_OUT } from '@futrli/auth/login/constants';

import { StoreState } from './types';

const getAuthenticatedUserId = (state: StoreState): string =>
  state.authReducers.authenticatedUser?.attributes?.sub || '';

export const clearQueryCacheOnAuthBoundary: Middleware<unknown, StoreState> = ({ getState }) => next => action => {
  const previousUserId = getAuthenticatedUserId(getState());
  const isExplicitSignOut = action.type === SIGN_OUT.ACTION;

  const result = next(action);
  const currentUserId = getAuthenticatedUserId(getState());

  if (isExplicitSignOut || previousUserId !== currentUserId) {
    Logger.info('Clearing query cache due to auth boundary change');
    queryClient.clear();
  }

  return result;
};
